import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { StudentData } from "../models/student-data.model";
import { StudentForm } from "../models/student-form";

export namespace StudentActions {
    @logDispatcher
    export class AddStudent {
      static readonly type = '[Student] AddStudent';
      constructor(public exerciseId: number, public user: string) {}
    }

    @logDispatcher
    export class AddStudentSuccess {
      static readonly type = '[Student] AddStudentSuccess';
      constructor(public studentForm: StudentForm, public studentId: number) {}
    }

    @logDispatcher
    export class AddStudentFail {
      static readonly type = '[Student] AddStudentFail';
      constructor(public error: any) {}
    }

    @logDispatcher
    export class DeleteStudent {
      static readonly type = '[Student] DeleteStudent';
      constructor(public student: StudentData, public familyId: number, public user: string) {}
    }

    @logDispatcher
    export class DeleteStudentSuccess {
      static readonly type = '[Student] DeleteStudentSuccess';
      constructor(public studentId: number) {}
    }

    @logDispatcher
    export class SetStudentDefaultState {
      static readonly type = '[Student] SetStudentDefaultState';
      constructor() {}
    }

    @logDispatcher
    export class Error {
      static readonly type = '[Student] Error';
      constructor(public error: any, public details: string) {}
    }
}
